import useAmplitude from 'lib/amplitude-tracking';
import {
    passkeyCreationStarted,
    passkeyCreated,
    currentUserLogged,
    enhancedSecurityModalOpened,
    enhancedSecurityToggleChanged,
    enhancedSecurityEnabled,
    enhancedSecurityDisabled,
    enhancedSecuritySaveFailed,
    enhancedSecurityMfaDeviceResetClicked,
    recoveryMobileNumberSetupStarted,
    recoveryMobileNumberSetupSuccessful,
    recoveryMobileNumberSetupFailed,
    recoveryMobileNumberCreationStarted,
    recoveryMobileNumberEditStarted,
    recoveryMobileNumberEditSuccessful,
    recoveryMobileNumberEditFailed,
    recoveryMobileNumberDeleted,
    recoveryMobileNumberDeletionStarted,
    recoveryMobileNumberDeletionFailed,
    recoveryMobileNumberVerificationFailed,
    recoveryMobileNumberSendCodeFailed,
    recoveryMobileNumberResendCodeFailed,
    personalInfoPageViewed,
    signInSecurityPageViewed,
    developerToolsPageViewed,
    personalInfoEditStarted,
    personalInfoSaved,
    personalInfoSaveFailed,
    avatarEditStarted,
    avatarUploaded,
    avatarUploadFailed,
    avatarResetToDefault,
    avatarResetFailed,
    emailEditStarted,
    emailChanged,
    emailChangeFailed,
    emailVerificationSent,
    emailVerificationFailed,
    recoveryEmailChanged,
    recoveryEmailChangeFailed,
    emailSubscriptionOptOutClicked,
    passwordEditStarted,
    passwordChanged,
    passwordChangeFailed,
    socialAccountConnectionStarted,
    socialAccountDisconnected,
    socialAccountConnectionFailed,
    socialAccountsModalOpened,
    devicesModalOpened,
    deviceApproved,
    deviceReported,
    deviceDisconnected,
    deviceDisconnectionFailed,
    deviceApprovalFailed,
    personalAccessTokenCreated,
    personalAccessTokenDeleted,
    personalAccessTokenCreationFailed,
    enhancedSecuritySetupStarted
} from 'modules/tracking/tracking-constants';

const useAmplitudePageView = () => {
    const { track } = useAmplitude();

    return (eventName, payload = {}) => {
        let amplitudeEventName;

        switch(eventName) {
            case passkeyCreationStarted:
                amplitudeEventName = 'Passkey - initiated';
                break;

            case passkeyCreated:
                amplitudeEventName = 'Passkey - created';
                break;

            case currentUserLogged:
                amplitudeEventName = 'User - first landing';
                break;

            case enhancedSecurityModalOpened:
                amplitudeEventName = 'Enhanced Security - modal opened';
                break;

            case enhancedSecurityToggleChanged:
                amplitudeEventName = 'Enhanced Security - toggle changed';
                break;

            case enhancedSecurityEnabled:
                amplitudeEventName = 'Enhanced Security - enabled';
                break;

            case enhancedSecurityDisabled:
                amplitudeEventName = 'Enhanced Security - disabled';
                break;

            case enhancedSecuritySaveFailed:
                amplitudeEventName = 'Enhanced Security - save failed';
                break;

            case enhancedSecurityMfaDeviceResetClicked:
                amplitudeEventName = 'Enhanced Security - MFA device reset clicked';
                break;

            case recoveryMobileNumberSetupStarted:
                amplitudeEventName = 'Recovery Mobile Number - setup started';
                break;

            case recoveryMobileNumberSetupSuccessful:
                amplitudeEventName = 'Recovery Mobile Number - setup successful';
                break;

            case recoveryMobileNumberSetupFailed:
                amplitudeEventName = 'Recovery Mobile Number - setup failed';
                break;

            case recoveryMobileNumberEditFailed:
                amplitudeEventName = 'Recovery Mobile Number - edit failed';
                break;

            case recoveryMobileNumberDeletionFailed:
                amplitudeEventName = 'Recovery Mobile Number - deletion failed';
                break;

            case recoveryMobileNumberVerificationFailed:
                amplitudeEventName = 'Recovery Mobile Number - verification failed';
                break;

            case recoveryMobileNumberSendCodeFailed:
                amplitudeEventName = 'Recovery Mobile Number - send code failed';
                break;

            case recoveryMobileNumberResendCodeFailed:
                amplitudeEventName = 'Recovery Mobile Number - resend code failed';
                break;

            case recoveryMobileNumberCreationStarted:
                amplitudeEventName = 'Recovery Mobile Number - creation started';
                break;

            case recoveryMobileNumberEditStarted:
                amplitudeEventName = 'Recovery Mobile Number - edit started';
                break;

            case recoveryMobileNumberEditSuccessful:
                amplitudeEventName = 'Recovery Mobile Number - edit successful';
                break;

            case recoveryMobileNumberDeleted:
                amplitudeEventName = 'Recovery Mobile Number - deleted';
                break;

            case recoveryMobileNumberDeletionStarted:
                amplitudeEventName = 'Recovery Mobile Number - deletion started';
                break;

            // Page view events
            case personalInfoPageViewed:
                amplitudeEventName = 'Page View - Personal Info';
                break;

            case signInSecurityPageViewed:
                amplitudeEventName = 'Page View - Sign In & Security';
                break;

            case developerToolsPageViewed:
                amplitudeEventName = 'Page View - Developer Tools';
                break;

            // Personal Info events
            case personalInfoEditStarted:
                amplitudeEventName = 'Personal Info - edit started';
                break;

            case personalInfoSaved:
                amplitudeEventName = 'Personal Info - saved';
                break;

            case personalInfoSaveFailed:
                amplitudeEventName = 'Personal Info - save failed';
                break;

            case avatarEditStarted:
                amplitudeEventName = 'Avatar - edit started';
                break;

            case avatarUploaded:
                amplitudeEventName = 'Avatar - uploaded';
                break;

            case avatarUploadFailed:
                amplitudeEventName = 'Avatar - upload failed';
                break;

            case avatarResetToDefault:
                amplitudeEventName = 'Avatar - reset to default';
                break;

            case avatarResetFailed:
                amplitudeEventName = 'Avatar - reset failed';
                break;

            // Email events
            case emailEditStarted:
                amplitudeEventName = 'Email - edit started';
                break;

            case emailChanged:
                amplitudeEventName = 'Email - changed';
                break;

            case emailChangeFailed:
                amplitudeEventName = 'Email - change failed';
                break;

            case emailVerificationSent:
                amplitudeEventName = 'Email - verification sent';
                break;

            case emailVerificationFailed:
                amplitudeEventName = 'Email - verification failed';
                break;

            case recoveryEmailChanged:
                amplitudeEventName = 'Email - recovery email changed';
                break;

            case recoveryEmailChangeFailed:
                amplitudeEventName = 'Email - recovery email change failed';
                break;

            case emailSubscriptionOptOutClicked:
                amplitudeEventName = 'Email Subscription - unsubscribe clicked';
                break;

            // Password events
            case passwordEditStarted:
                amplitudeEventName = 'Password - edit started';
                break;

            case passwordChanged:
                amplitudeEventName = 'Password - changed';
                break;

            case passwordChangeFailed:
                amplitudeEventName = 'Password - change failed';
                break;

            // Social account events
            case socialAccountConnectionStarted:
                amplitudeEventName = 'Social Account - connection started';
                break;

            case socialAccountDisconnected:
                amplitudeEventName = 'Social Account - disconnected';
                break;

            case socialAccountConnectionFailed:
                amplitudeEventName = 'Social Account - connection failed';
                break;

            case socialAccountsModalOpened:
                amplitudeEventName = 'Social Accounts - modal opened';
                break;

            // Device events
            case devicesModalOpened:
                amplitudeEventName = 'Devices - modal opened';
                break;

            case deviceApproved:
                amplitudeEventName = 'Devices - device approved';
                break;

            case deviceReported:
                amplitudeEventName = 'Devices - device reported';
                break;

            case deviceDisconnected:
                amplitudeEventName = 'Devices - device disconnected';
                break;

            case deviceDisconnectionFailed:
                amplitudeEventName = 'Devices - disconnection failed';
                break;

            case deviceApprovalFailed:
                amplitudeEventName = 'Devices - device approval failed';
                break;

            // Developer Tools events
            case personalAccessTokenCreated:
                amplitudeEventName = 'Developer Tools - token created';
                break;

            case personalAccessTokenDeleted:
                amplitudeEventName = 'Developer Tools - token deleted';
                break;

            case personalAccessTokenCreationFailed:
                amplitudeEventName = 'Developer Tools - token creation failed';
                break;

            case enhancedSecuritySetupStarted:
                amplitudeEventName = 'Enhanced Security - setup started';
                break;

            default:
                amplitudeEventName = eventName;
        }

        return track(amplitudeEventName, payload);
    };
};

export default useAmplitudePageView;
